export function retryLazy<T>(
  importFn: () => Promise<T>,
  retries = 2,
  delay = 200,
): Promise<T> {
  return new Promise((resolve, reject) => {
    function attempt(triesLeft: number) {
      importFn()
        .then(resolve)
        .catch(error => {
          if (triesLeft === 0) {
            // Optionally reload the page here
            window.location.reload();
            reject(error);
          } else {
            setTimeout(() => attempt(triesLeft - 1), delay);
          }
        });
    }

    attempt(retries);
  });
}
